import type { PayloadAction } from "@reduxjs/toolkit";
import { createListenerMiddleware, createSlice } from "@reduxjs/toolkit";

import { type CookieConsent, getCookieConsentState, initServicesForConsent, setCookieConsentState } from "@/utils/cookieConsent";

interface CookieConsentState {
  consent: CookieConsent | undefined;
}

const initialState: CookieConsentState = {
  consent: getCookieConsentState()
} satisfies CookieConsentState;

const cookieConsentSlice = createSlice({
  name: "cookieConsent",
  initialState,
  reducers: {
    setConsent(state, action: PayloadAction<CookieConsent>) {
      state.consent = action.payload;
    }
  },
  selectors: {
    selectConsent: (state) => state.consent
  }
});

const cookieConsentListener = createListenerMiddleware();

cookieConsentListener.startListening({
  actionCreator: cookieConsentSlice.actions.setConsent,
  effect: (action) => {
    setCookieConsentState(action.payload);
    initServicesForConsent(action.payload);
  }
});

export const { setConsent } = cookieConsentSlice.actions;
export const { selectConsent } = cookieConsentSlice.selectors;
export { cookieConsentListener };
export default cookieConsentSlice.reducer;
